import request from '@/utils/request'

export default {
  // 检查手机号是否注册
  checkMobile(mobile) {
    return request({
      url: `/sms/checkMobile/${mobile}`,
      method: 'get',
      hideError: true
    })
  },

  // 获取验证码
  getVerificationCode(mobile) {
    return request({
      url: `/sms/getVerificationCode/${mobile}`,
      method: 'get'
    })
  },

  // 手机号登录
  login(data) {
    return request({
      url: '/sms/login',
      method: 'post',
      data
    })
  },

  // 手机号注册
  register(data) {
    return request({
      url: '/sms/register',
      method: 'post',
      data
    })
  }
}
